import {Component, forwardRef, ViewChild, AfterViewInit} from '@angular/core';
import { NG_VALUE_ACCESSOR, NG_VALIDATORS, NgControl } from '@angular/forms';
import { AbstractWorkflowFormComponent } from '../../@core/abstract-workflow-form-component';
import { TextboxModel } from '../textbox.model';
import { Model_WorkflowComponent } from 'src/app/app.models';
import { TextBoxComponent } from '@progress/kendo-angular-inputs';

@Component({
    selector: 'abw-textbox-form',
    providers: [
      {
        provide: NG_VALUE_ACCESSOR,
        useExisting: forwardRef(() => TextboxFormComponent),
        multi: true
      },
      {
        provide: NG_VALIDATORS,
        useExisting: forwardRef(() => TextboxFormComponent),
        multi: true
      }
    ],
    templateUrl: './textbox-form.component.html',
    styleUrls: ['./textbox-form.component.scss']
})
export class TextboxFormComponent extends AbstractWorkflowFormComponent<TextboxModel, string> implements AfterViewInit {
  @ViewChild('kTextbox') public textbox: TextBoxComponent;

  ngAfterViewInit() {
    super.ngAfterViewInit();
    if (!!this.textbox) {
      this.textbox.input.nativeElement.type = this.getInputType();
    }
  }

  getInputType() {
		const workflowComponent = (this.model as any).additional as Model_WorkflowComponent;
    if (workflowComponent.INPUT_TYPE == 'password') {
      return 'password';
    }
    return 'text';
  }
}